/**
 * Open Stripe Checkout with the stored JWT on the request.
 */

import axios from 'axios';
import { trackBeginCheckout } from './analytics';
import { readStoredAccessToken, syncAxiosAuth } from './authStorage';

/**
 * Create a Checkout Session and redirect. Stays on the current page on error
 * (do not dump the user to /pricing — that is where Carmen/Paco dropped).
 *
 * @param {{ kind: string, returnPath?: string }} opts
 * @returns {Promise<void>}
 */
export const startStripeCheckout = async ({ kind, returnPath } = {}) => {
  const access = readStoredAccessToken();
  syncAxiosAuth(axios, access);
  const { data } = await axios.post('/api/cvs/create-checkout-session/', {
    kind,
    return_path: returnPath || window.location.pathname,
  });
  if (!data?.url) {
    throw new Error('missing_checkout_url');
  }
  await trackBeginCheckout({ kind });
  window.location.assign(data.url);
};
